
import React from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface RecentSitesProps {
  sites: string[];
  onSiteSelect: (site: string) => void;
}

export const RecentSites: React.FC<RecentSitesProps> = ({ sites, onSiteSelect }) => {
  const { t } = useTranslation();
  
  if (sites.length === 0) return null;
  
  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium">{t('recentSites.title')}</h3>
      <div className="grid grid-cols-1 gap-2">
        {sites.map((site, index) => (
          <Button 
            key={index} 
            variant="outline" 
            className="w-full justify-start text-left"
            onClick={() => onSiteSelect(site)}
          >
            {site}
          </Button>
        ))}
      </div>
    </div>
  );
};
